module.exports = __webpack_public_path__ + "media/images/gray-cab6ca9911ac8a9f207226815dc21868.svg";